<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('WorkHours') |ToUppercase">
                <vs-button class="" color="success" type="filled" to="/work-hours/add">{{$t('AddWorkHours')}}</vs-button>

                <div class="vx-row">
                    <vs-divider/>
                    <div class="vx-col sm:w-1/2 md:w-2/5 w-full" v-if="admin == 'admin'">
                        <small>{{$t('User') |ToUppercase}}</small><br>
                        <vs-select v-model="selectedUserId" class="selectExample w-full mb-3">
                            <vs-select-item v-for="(item,index) in users" :key="index" :text="item.firstname + ' ' + item.lastname" :value="item.id"/>
                        </vs-select>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/5 w-full">
                        <small>{{$t('DateFrom') |ToUppercase}}</small><br>
                        <datepicker v-model="dateFrom"></datepicker>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/5 w-full">
                        <small>{{$t('DateTo') |ToUppercase}}</small><br>
                        <datepicker v-model="dateTo"></datepicker>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/5 w-full">
                        <vs-button class="mt-6" color="success" type="filled" @click="searchWorkHours()">{{$t('Search')}}</vs-button>
                    </div>
                </div>

                <vs-table :noDataText="$t('NoWorkHoursFound')" max-items="14" pagination search :data="workHours">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th sort-key="id">{{ $t("User") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("Date") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("Shift") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("WorkHours") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("ExtraHours") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("Explanation") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("Total") }}</vs-th>
                        <vs-th v-if="admin == 'admin'" sort-key="id">{{ $t("Actions") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].user_name}}</vs-td>
                                <vs-td>{{ data[index].date_formated}}</vs-td>
                                <vs-td>{{ data[index].shift_name}}</vs-td>
                                <vs-td>{{ data[index].duration}}</vs-td>
                                <vs-td>{{ data[index].extra_hours}}</vs-td>
                                <vs-td>{{ data[index].explanation}}</vs-td>
                                <vs-td>{{ data[index].duration + data[index].extra_hours}}</vs-td>
                                <vs-td v-if="admin == 'admin'" class="grid justify-items-start">
                                    <vs-button color="primary" class="float-left mr-2" @click="$router.push('/work-hours/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                    <vs-button color="primary" class="float-left" @click="deleteWorkHour(data[index].id)" type="border" icon="delete" >{{$t('Delete') | ToUppercase}}</vs-button>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>

                <div class="vx-row">
                    <div class="vx-col w-full text-center">
                        <h5>{{$t('SearchWorkHours')}}: {{totalTime}}</h5>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                workHours: [],
                users: [],
                userId: 0,
                admin: '',
                selectedUserId: 0,
                totalTime: 0,
                dateFrom: null,
                dateTo: null,
            };
        },
        methods: {
            updateWorkHours(userId) {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/work-hour/?type=byUser&userId=' + userId + '&dateFrom=' + this.dateFrom + '&dateTo=' + this.dateTo)
                .then(function (response) {
                    thisIns.workHours = response.data;
                    thisIns.calculateTotal();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            calculateTotal() {
                this.totalTime = 0;
                for (var i = 0; i < this.workHours.length; i++) {
                    this.totalTime = this.totalTime + this.workHours[i].duration + this.workHours[i].extra_hours;
                }
            },
            searchWorkHours() {
                this.$vs.loading();
                var selectedUser = 0;
                if(this.admin == 'admin') {
                    if(this.dateFrom == null || this.dateTo == null || this.selectedUserId == 0) {
                        this.$vs.notify({
                            text: "Vnesite vse podatke iskanja.",
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                        return;
                    }
                    selectedUser = this.selectedUserId;
                }
                else {
                    if(this.dateFrom == null || this.dateTo == null) {
                        this.$vs.notify({
                            text: "Vnesite vse podatke iskanja.",
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                        return;
                    }
                    selectedUser = this.userId;
                }

                const thisIns = this;
                this.$http.post('/work-hour/search', {
                    user_id: selectedUser,
                    date_from: new Date(thisIns.dateFrom.getFullYear(), thisIns.dateFrom.getMonth(), thisIns.dateFrom.getDate(), 0, 0, 0),
                    date_to: new Date(thisIns.dateTo.getFullYear(), thisIns.dateTo.getMonth(), thisIns.dateTo.getDate(), 23, 59, 59),
                }).then(function (response) {
                    console.log(response);
                    thisIns.workHours = response.data;
                    thisIns.calculateTotal();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateUsers() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/users/')
                .then(function (response) {
                    thisIns.users = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            deleteWorkHour(id) {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.delete('/work-hour/' + id)
                .then(function (response) {
                    thisIns.searchWorkHours();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri brisanju ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.userId = userInfo.uid;
            this.admin = userInfo.userRole;

            //this.updateWorkHours(this.userId);
            if(this.admin == 'admin') {
                this.updateUsers();
            }
            var date = new Date();
            this.dateFrom = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
            this.dateTo = new Date(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0);
            this.selectedUserId = this.userId;
            this.searchWorkHours();
        },
    };
</script>